import { TitleHeader } from "./title-header"

interface NotFoundProps {
  title?: string
  message?: string
}

export function NotFound({ title = "Не найдено", message = "Страница не существует" }: NotFoundProps) {
  return (
    <div className="flex flex-col h-dvh">
      <TitleHeader title={title} />
      <div className="flex-1 flex items-center justify-center p-m">
        <div className="text-center text-muted-foreground">
          <p className="text-lg">{message}</p>
        </div>
      </div>
    </div>
  )
}
